import { useEffect } from 'react';
import { useToast } from '../../../components/ui/use-toast.tsx';
import { useAppState } from '../../../lib/hooks/use-app-state.ts';
import type { SalesDraftType } from '../../../server/types/drafts-types.ts';
import { api } from '../../../utils/api.ts';

type Options = {
    customerId: string | null | undefined;
    orderType: SalesDraftType;
};

export const useSalesDraftDefaults = ({ customerId, orderType }: Options) => {
    const { platoUser } = useAppState();
    const { toast } = useToast();

    const result = api.platoUser.query.salesDraft.getSalesDraft.getDefaultHeader.useQuery(
        {
            customer_id: customerId ?? '',
            clerk_id: platoUser?.erpUserId ?? '',
            sales_order_type: orderType,
        },
        {
            enabled: !!customerId,
        },
    );

    useEffect(
        () => {
            if (result.error) {
                toast({
                    title: 'error',
                    description: result.error.message,
                    icon: 'warning',
                });
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps -- useToast doesn't return a stable ref
        [result.error],
    );

    return result;
};
